import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import Tooltip from '@anm/components/Tooltip';
import Image from '@anm/components/image/Image';
import getFromCdn from '@anm/helpers/getFromCdn';
import { truncateMultiline } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const TooltipWrapper = styled(Tooltip)`
  top: -4px;
  left: 22px;
  min-width: 325px;
  padding: 12px 20px;
  line-height: 22px;

  &:before {
    right: 83px;
  }
`;

export const AccountListWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled(TitleBlock)`
  margin-top: 32px;
  margin-bottom: 9px;
  h2,
  h3,
  h4,
  h5 {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    color: var(--gray_400);
  }
  ${TitleDescription} {
    font-size: 11px;
    line-height: 15px;
    color: var(--error);
  }
`;

export const DeleteButton = styled(Image)`
  top: 15px;
  right: 15px;
  cursor: pointer;
  position: absolute;
  width: 16px;
  height: 18px;
  display: none;
`;

export const EditButton = styled.span`
  color: var(--blue_100);
  font-weight: 600;
  cursor: pointer;
  position: absolute;
  top: 2px;
  left: -35px;
  pointer-events: all;
  &:before {
    content: 'Edit';
  }
`;

export const ReconnectButton = styled.span`
  color: var(--error);
  font-weight: 600;
  cursor: pointer;
  position: absolute;
  top: 2px;
  left: -90px;
  pointer-events: all;
  &:before {
    content: 'Reconnect';
  }
`;

export const DestinationRow = styled.div<{ isHoverStyle: boolean }>`
  display: flex;
  align-items: center;
  text-align: left;
  position: relative;
  justify-content: space-between;
  padding: 13px 10px;

  &:hover {
    ${DeleteButton} {
      display: block;
    }
  }

  ${({ isHoverStyle }) =>
    isHoverStyle &&
    css`
      cursor: pointer;
      &:hover {
        border-radius: 10px;
        background: ${({ theme }) => theme.destinationItemHover};
      }
    `}
`;

export const DestinationItemWrapper = styled.div<{ isDisconnected?: boolean }>`
  display: flex;
  padding-right: 10px;
  align-items: center;
  padding-right: ${({ isDisconnected }) => (isDisconnected ? 95 : 37)}px;
`;

export const AccountTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  margin-left: 16px;
  word-break: break-all;
  ${truncateMultiline('2')}
  color: ${({ theme }) => theme.textColor};
`;

export const Error = styled(Image)`
  margin-right: 8px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  position: relative;
  pointer-events: none;
`;

export const ConnectedLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #30aef2;
  padding: 4px 5px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background: #d9f2ff;
  border-radius: 4px;

  &:before {
    display: block;
    content: '';
    width: 14px;
    height: 14px;
    margin-right: 4px;
    background: url(${getFromCdn('images/icons/link_icon.svg')}) no-repeat center / cover;
  }
`;
